module.exports = __webpack_public_path__ + "static/media/Aamachamai Updated With Credits V2-1.1aa45676.mp4";